import React from 'react';
import { useOktaAuth } from '@okta/okta-react';
import Login from './pages/Login';
import SessionProvider from '@tcs/client-portal-common/providers/SessionProvider';
import NotificationProvider from '@tcs/client-portal-common/providers/NotificationProvider';
import PersonaSelector from './components/atoms/PersonaSelector';
import IdleTimer from '@tcs/client-portal-common/components/molecules/IdleTimer';
import { ToastUtilsConfigurator } from '@forgeglobal/design-framework';
import { SnackbarProvider } from 'notistack';

export const RequiredAuth: React.FC = () => {
  const { authState } = useOktaAuth();

  // if not logged in, redirect back to login
  if (!authState || !authState?.isAuthenticated) {
    return <Login />;
  }

  // we need to determine type of user and route them properly to their index
  return (
    <SessionProvider>
      <SnackbarProvider
        maxSnack={3}
        autoHideDuration={5000}
        preventDuplicate={true}>
        <ToastUtilsConfigurator />
        <NotificationProvider>
          <PersonaSelector />
          <IdleTimer />
        </NotificationProvider>
      </SnackbarProvider>
    </SessionProvider>
  );
};
